var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGenderNeuter = function SvgIconGenderNeuter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 17.436A7.752 7.752 0 0 0 12 2a7.75 7.75 0 0 0-1 15.436v4.314a1 1 0 1 0 2 0zM6.25 9.75a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconGenderNeuter;